import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';
import PaperMaterial from '@material-ui/core/Paper';
import Can from '~/contexts/Can';
import { AbilityContext } from '~/contexts/Can';
import Epay from './Epay';
import MercadoPago from './MercadoPago';
import Cielo from './Cielo';
import Asaas from './Asaas';

const useStyles = makeStyles(() => ({
  root: {
    padding: '15px 0px 0px 0px',
  },
}));

function Tabs() {
  const { t } = useTranslation();
  const classes = useStyles();
  const ability = useContext(AbilityContext);
  const [value, setValue] = React.useState('3');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <TabContext value={value}>
      <PaperMaterial>
        <TabList
          variant="scrollable"
          textColor="secondary"
          onChange={handleChange}
        >
          <Tab
            label={t('sales.tabs.epay')}
            value="1"
            disabled={ability.cannot('list', 'Epay')}
          />
          <Tab
            label={t('mercadopago')}
            value="2"
            disabled={ability.cannot('list', 'MercadoPago')}
          />
          <Tab
            label={`${t('cielo')}/${t('braspag')}`}
            value="3"
            disabled={ability.cannot('list', 'Cielo')}
          />
          <Tab
            label={`${t('asaas')}`}
            value="4"
            disabled={ability.cannot('list', 'Asaas')}
          />

        </TabList>
      </PaperMaterial>

      <Can I="list" a="Epay">
        <TabPanel className={classes.root} value="1">
          <Epay />
        </TabPanel>
      </Can>

      <Can I="list" a="MercadoPago">
        <TabPanel className={classes.root} value="2">
          <MercadoPago />
        </TabPanel>
      </Can>

      <Can I="list" a="Cielo">
        <TabPanel className={classes.root} value="3">
          <Cielo />
        </TabPanel>
      </Can>

      <Can I="list" a="Asaas">
        <TabPanel className={classes.root} value="4">
          <Asaas />
        </TabPanel>
      </Can>
    </TabContext>
  );
}

export default React.memo(Tabs);
